import './component.scss'
import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

const TOGGLE_TEXT_ROOT_SELECTOR = '.js-toggleText-root'
const TOGGLE_TEXT_OPEN_SELECTOR = '.js-toggleText-open'
const TOGGLE_TEXT_CLOSE_SELECTOR = '.js-toggleText-close'
const TOGGLE_TEXT_TARGET_SELECTOR = '.js-toggleText-target'

$(() => {
  $(TOGGLE_TEXT_OPEN_SELECTOR).on('click', (event) => {
    const $openTrigger = $(event.currentTarget)
    const $root = $openTrigger.closest(TOGGLE_TEXT_ROOT_SELECTOR)
    const $target = $root.find(TOGGLE_TEXT_TARGET_SELECTOR)

    $openTrigger.hide()
    $target.show()
  })

  $(TOGGLE_TEXT_CLOSE_SELECTOR).on('click', (event) => {
    const $closeTrigger = $(event.currentTarget)
    const $root = $closeTrigger.closest(TOGGLE_TEXT_ROOT_SELECTOR)
    const $target = $root.find(TOGGLE_TEXT_TARGET_SELECTOR)
    const $openTrigger = $root.find(TOGGLE_TEXT_OPEN_SELECTOR)

    $openTrigger.show()
    $target.hide()
  })
})
